export const blockIconsSocialEmojiObjects = (
	<span className='material-symbols-outlined'>emoji_objects</span>
);
